<template>
  <div class="top-nav-wrapper">
    <!--    <a-tooltip title="刷新页面" @click="() => { this.$router.go(0) }">-->
    <!--      <a-icon type="reload" style="font-size: 18px;cursor: pointer;" />-->
    <!--    </a-tooltip>-->
    <!-- 下拉切换组件 -->
    <a-dropdown :trigger="['hover', 'click']">
      <a class="ant-dropdown-link" @click.prevent>
        <span style="font-size: 16px;font-weight: bold;margin-right: 6px; color: #252525">{{ tenantLabel }}</span>
        <a-icon type="caret-down" style="color: #252525" />
      </a>
      <a-menu slot="overlay">
        <a-menu-item v-for="item in tenantList" :key="item.id" @click="handleSwitch(item)">
          {{ item.name }}
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <!--Nav主体-->
    <a-menu v-model="currentApp" mode="horizontal" @select="switchSystem">
      <a-menu-item
        v-for="x in topNav"
        :key="x.name"
        :disabled="x.children.length < 1"
      >
        <a-icon :type="x.icon || 'smile'" v-show="x.icon" />
        {{ x.meta.abbr || x.meta.title || x.name }}
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
// 此文件内不能放任何异步操作！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！

import { mapState } from 'vuex'
// import store from '@/store'
import router, { resetRouter } from '@/router'
// import { queryTenantList } from '@/views/_setting/tenant/tenant'
// import { setRoute } from '@/router/generator-routers'

// import storage from 'store2'
// import { DYNAMIC_ROUTERS } from '@/store/mutation-types'
// import NProgress from 'nprogress'
// import { projectRouters } from '@/router/localRouterConfig/project'

export default {
  name: 'NavHeader',
  data () {
    return {
      currentApp: [],
      num: 0
      // currentTenant: 'tenant1',
      // tenantList: [
      //   { label: '租户一', value: 'tenant1' },
      //   { label: '租户二', value: 'tenant2' }
      // ]
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      addRouters: state => state.permission.addRouters,
      defaultSystemType: state => state.permission.defaultSystemType,
      topNav: state => state.permission.topNav,
      storeCurrentNav: state => state.permission.currentNav,
      info: state => state.user.info
    }),
    tenantLabel () {
      const tenant = this.tenantList.find(item => item.id === this.currentTenant)
      return tenant ? tenant.name : ''
    },
    tenantList () {
      return this.info.tenants || []
    },
    currentTenant () {
      return this.info.tenantId || ''
    }
  },
  created () {
    // 取当前域名作为nav的active
    // let activePath = location.origin
    // const arr = location.href.split('/')
    // const subPath = arr.find(e => e.indexOf('600ly') > -1)
    // if (subPath) {
    //   activePath = `${location.origin}/${subPath}`
    // }
    // this.$store.dispatch('SetCurrentNav', encodeURIComponent(activePath))

    // 设置默认子系统
    if (!this.$store.getters.currentNav) {
      this.$store.dispatch('SetCurrentNav', this.topNav[0].name)
    } else {
      const index = this.topNav.findIndex(e => e.name === this.$store.getters.currentNav)
      if (index < 0) {
        this.$store.dispatch('SetCurrentNav', this.topNav[0].name)
      }
    }
    this.currentApp = [this.storeCurrentNav]
  },
  mounted () {
    // this.queryTenantList()
  },
  methods: {
    // 切换子应用
    async switchSystem (item) {
      const nav = this.topNav.find(e => (e.name === item.key))
      console.log('切换子系统：', nav.children)
      await this.$store.dispatch('SetCurrentNav', item.key)
      this.$store.dispatch('GenerateRoutes', {}).then(() => {
        // 动态添加可访问路由表
        // VueRouter@3.5.0+ New API
        resetRouter() // 重置路由 防止退出重新登录或者 token 过期后页面未刷新，导致的路由重复添加
        this.$store.getters.addRouters.forEach(r => {
          router.addRoute(r)
        })
        this.$router.push({ path: '/' })
      })

      // 如果跳转到外部
      // const path = decodeURIComponent(e.key)
      // const item = this.topNav.find(e1 => (e1.path === path || e1.id === path))
      // const userId = this.$store.getters.userInfo.user_id
      // const token = this.$store.getters.token
      // await this.$store.dispatch('SetCurrentNav', e.key)
      // console.log('切换子系统', e, item)
      // if (path) {
      //   // 临时，对接收费客服系统，演示
      //   if (path.indexOf('http') === -1) {
      //     this.$router.push({
      //       path: '/jump',
      //       query: { path }
      //     })
      //   } else {
      //     const url = `${path}?userId=${userId}&token=${token}&projectId=${this.storeCurrentProject}`
      //     // const tempwindow = window.open()
      //     // tempwindow.location = url
      //     location.href = url
      //   }
      // } else {
      //   // NProgress.done()
      //   alert('该子应用正在建设中或未分配资源路径。')
      // }
    },
    /* queryTenantList () {
      queryTenantList().then(res => {
        console.log('获取的租户列表===>', res)
        if (res.success === 1) {
          const data = res.dataMap.data
          console.log('租户列表的list===>', data)
          this.tenantList = data.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      })
    }, */
    handleSwitch (item) {
      // 这里写点击切换的逻辑
      console.log('切换到：', item)
      // this.currentTenant = item.value
      if (item.id === this.currentTenant) return false
      this.$store.dispatch('changeTenant', item.id).then(res => {
        if(process.env.VUE_APP_ELECTRON) {
          const { ipcRenderer } = require('electron')
          ipcRenderer.send('force-reload')
        } else {
          location.reload()
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.top-nav-wrapper {
  display: flex;
  align-items: center;

  .anticon.anticon-appstore {
    font-size: 18px;
    padding: 0 23px;
    cursor: pointer;
  }
}
</style>
